import get from "lodash.get";

type FormFieldErrorProps = {
  errors: Record<string, string>;
  name: string;
  className?: string;
};

export default function FormFieldError({
  errors,
  name,
  className = "",
}: FormFieldErrorProps) {
  if (!get(errors, name)) return null;

  return (
    <p className={`mt-1 text-right text-sm text-danger ${className}`}>
      {get(errors, name)}
    </p>
  );
}
